import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annuler-devis',
  templateUrl: './annuler-devis.component.html',
  styleUrls: ['./annuler-devis.component.scss']
})
export class AnnulerDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
